import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FormsModule, NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { BillingService } from 'src/app/billing/billing.service';
import { ClientService } from 'src/app/client/client.service';
import { TimesheetsService } from 'src/app/manageprofile/Timesheet.service';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { WipControlService } from 'src/app/shared/wipcontrol.service';
import { TaxType } from '../../../Models/billing';
import { Disbursement } from '../../../Models/Disbursement';
import { DisbursementService } from '../../disbursement.service';

@Component({
  selector: 'app-add-disbursement',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatButtonModule, MatIconModule],
  templateUrl: './add-disbursement.component.html',
  styleUrls: ['./add-disbursement.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS},
  ],
})

export class AddDisbursementComponent implements OnInit, OnDestroy {
  @Output() closeDisbursePopUp = new EventEmitter<{
    customField: any;
    disbursement: any;
  } | false>();
  @Output() clickgraphgenerate = new EventEmitter();
  @Input() jid: any;
  @Input() jcode: any;
  @Input() jname: any;
  @Input() isEditMode: boolean;
  public data: {
    dsid: any;
    isEditMode: boolean;
    jobId: any;
    jobName: any;
    jobCodeQry: any;
    jobIdStr: any;
    isOpenFromQuickLinks: boolean;
  };
  public disbursement : any = new Disbursement();
  public isEditDisbursement: boolean =false;
  showdistextbox: boolean = false
  showdiselect: boolean = false
  public titlePopUp: string;
  public jobIds: any
  datemaxlength: number = 8;
  private disburseTextReq: boolean = false;
  public isButtonDisabled: boolean = false;
  public invoiceMinDate: Date;
  public maxLength = 0;
  public checkerrordescription: boolean = false;
  public disbursementClientList: { [key: string]: Object }[] = [];
  public isOpenedFromQuickAction:boolean = false;
  tempDsId: any;
  dropDownDisburseReq: boolean;
  untiPOrMarkUpRequired: boolean;
  unsubscribe = new Subject<void>();
  public bsModalRef: BsModalRef;
  taxTypes: TaxType[] = []
  selectedTaxTypeId: number | null = null;
  public isDisableIncludeTax: boolean = true;
  isIncludeTaxChecked: boolean = false;

  constructor(private disbursementService: DisbursementService, private toastr: ToastrService, public datepipe: DatePipe, private _BillingService: BillingService, private _clientService: ClientService, private _timesheetService: TimesheetsService,private _wipControlService: WipControlService) {}

  ngOnInit() {
      this.titlePopUp = 'Add disbursement'
      this.GetMinInvoiceDate();
      if (this.jobIds == undefined) {
          if (!(this.data.jobIdStr == undefined || this.data.jobIdStr == 0)) {
              this.jobIds = this.data.jobIdStr;
          }
      }

      if(this.data.isOpenFromQuickLinks){
        this.isOpenedFromQuickAction = this.data.isOpenFromQuickLinks;
        this.getDisbursementClientList();
      } else {
        this.getInoviceJobs();
      }
      if (this.data) {
          this.doLoadData(this.data.dsid, this.data.isEditMode, this.data.jobId, this.data.jobName, this.data.jobCodeQry);
      }
      this.maxLength = 0;

      // Fetch GST options from API
      this.getTaxOptions();
  }

    // Method to fetch GST options from the API
    getTaxOptions() {
      this._BillingService.getAllTaxTypes().pipe(takeUntil(this.unsubscribe)).subscribe((result: TaxType[]) => {
        if (Array.isArray(result)) {
          this.taxTypes = result;

          // Find default tax
          const defaultTax = this.taxTypes.find(x => x.isDefault);

          // Assign only taxTypeId
          this.selectedTaxTypeId = defaultTax?.taxTypeId
            ?? this.taxTypes[0]?.taxTypeId
            ?? null;
        }
      });
    }

    calculateTaxRate(includeTax: boolean = false): void {

      if (
        this.disbursement.unitCost == null ||
        this.disbursement.unitCost == undefined ||
        this.selectedTaxTypeId <= 0
      ) {
        this.isDisableIncludeTax = true;
        return;
      }

      this.isDisableIncludeTax = false;

      const amount = this.disbursement.noOfUnits * this.disbursement.unitCost;

      const selectedTax = this.taxTypes.find(
        x => x.taxTypeId === this.selectedTaxTypeId
      );

      const taxRate = Number(selectedTax?.taxRate ?? 0);

      // Default values
      this.subTotal = amount;
      this.GSTValue = 0;
      this.total = amount;

      if (taxRate > 0) {
        if (includeTax) {
          // Tax included in entered amount
          this.GSTValue = (amount * taxRate) / (100 + taxRate);
          this.total = amount;
          this.subTotal = this.total - this.GSTValue;
        } else {
          // Tax excluded from entered amount
          this.GSTValue = (amount * taxRate) / 100;
          this.subTotal = amount;
          this.total = this.subTotal + this.GSTValue;
        }
      }

      // Assign values
      this.disbursement.GST = selectedTax?.taxName;
      this.disbursement.isTaxInclude = includeTax;
      this.disbursement.GSTValue = this.GSTValue.toFixed(2);
      this.disbursement.subTotal = this.subTotal.toFixed(2);
      this.disbursement.total = this.total.toFixed(2);
    }

    toggleIncludeTax(event: any): void {
      this.isIncludeTaxChecked =
        event.checked || event.target?.checked;
      this.calculateTaxRate(this.isIncludeTaxChecked);
    }

    disbursementCostCalc() {  //Hemanth Kumar, CUST-2269, 25-07-24 (Logic Updated)
      if (this.selectedTaxTypeId > 0) {
        this.isDisableIncludeTax = false;
      }
      else {
        this.isDisableIncludeTax = true;
      }
      this.calculateTaxRate(this.isIncludeTaxChecked);
    }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  doLoadData(dsid, isEditMode, jobId,jobName,jobCode) {
    if (isEditMode) {
      this.isEditDisbursement = isEditMode;
      this.titlePopUp = 'Edit disbursement';
      this.tempDsId = dsid;
      this.disbursement = new Disbursement();
      this.getDisbursementbyId(dsid);
    }
    else {
      this.GetDisbursementMasterCombo();
      this.disbursement = new Disbursement(); 
      this.disbursement.jobId = jobId;
      this.disbursementJobTitle(jobId, jobCode, jobName)
      this.disbursement.disbursementDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    }
    this.disburseTextReq = false; this.dropDownDisburseReq = false; this.untiPOrMarkUpRequired = false;
  }
  disbur(event) {    
    this.disbursement.disbursementMasterRefId = event.disbursementMasterId;
    
    if (this.disbursement.disbursementMasterRefId == "1333") {
      this.showdistextbox = true;
      this.showdiselect = false;
      this.disburseTextReq = true;
    }
    else {
      this.showdistextbox = false;
      this.showdiselect = true;
      this.getDisbursementMasterbyId(this.disbursement.disbursementMasterRefId);
      this.dropDownDisburseReq = false;
    }
  }
  Savedisname() {
     
    if (this.disbursement.name != "") {
      this.showdistextbox = true;
      this.showdiselect = false;
      this.disburseTextReq = false;
    }
    else {
      this.showdistextbox = false;
      this.showdiselect = true;
    }
  }
  validate() {
    if (this.disbursement.name != undefined && this.disbursement.name=='') {
      this.disburseTextReq = true;
      return false;
    }
    else if (this.disbursement.disbursementMasterRefId == null || this.disbursement.disbursementMasterRefId == undefined) {
      this.dropDownDisburseReq = true;
      return false;
    }
    this.disburseTextReq = false; this.dropDownDisburseReq = false; this.untiPOrMarkUpRequired = false;
    return true;
  }
  public validateDate: boolean = false;
  public validateDescription: boolean = false;
  public validateSupplierName: boolean = false;
  public validatenoOfUnits: boolean = false;
  public validateUnitCost: boolean = false;  
  public GSToption:number=undefined;

  checkFormvalidation() { // Dev:Ramya; CUST-1815; 28Nov2022
    if (this.disbursement.disbursementDate === undefined || this.disbursement.disbursementDate === "" ) {
      this.validateDate = true;     
    } else {
      this.validateDate = false;
    }
    if (this.disbursement.description === undefined || this.disbursement.description === "") {
      this.validateDescription = true;     
    } else {
      this.validateDescription = false;     
    }
    if (this.disbursement.supplierName === undefined || this.disbursement.supplierName === "") {
      this.validateSupplierName= true;
    } else {
      this.validateSupplierName= false;
    }
    if (this.disbursement.noOfUnits === undefined || this.disbursement.noOfUnits === "") {
      this.validatenoOfUnits= true;
    } else {
      this.validatenoOfUnits= false;
    }
    if (this.disbursement.unitCost === undefined || this.disbursement.unitCost === "") {
      this.validateUnitCost= true;
    } else {
      this.validateUnitCost= false;
    }
    this.validate();
    if (this.validateDate || this.validateSupplierName || this.validatenoOfUnits || this.validateUnitCost || this.disburseTextReq ) {
    return true;
    }else {
    return false;
   }
  }

  public selectedClientID : number;
  public Invoicesummary: any = [];
  // Dev: Uzaif; CUST-7314; 24-07-2025
  disbursementClientDropdownChange(event:any){
    if(event !== undefined){
      this.disbursement.jobName = null;
      this.selectedClientID = event?.clientId;
      this._timesheetService.getClientJobsList(this.selectedClientID).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
          if (result) {
            this.Invoicesummary = result.filter(
              jobListData => jobListData?.jobCategory === 4 || jobListData?.jobCategory === 5 || jobListData?.jobCategory === 6 || jobListData?.jobCategory === 7
            );
          }
      })
    }
  }
  disbursementClientDropdownClear(){
    this.Invoicesummary = [];
    this.disbursement.jobName = null;
  }
  // Dev: Uzaif; CUST-7314; 24-07-2025 end
    getInoviceJobs() {
        let jobidsList = [];
        if (this.jobIds != undefined) { 
        let jobids = this.jobIds.toString().split(',');
        jobids.forEach(element => {
            jobidsList.push({ JobId: element });
        })
        this._BillingService.GetJobWIPInvoicesummary(JSON.stringify(jobidsList)).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
            this.Invoicesummary = result.invoicesummary;
            this.disbursement.jobName = this.Invoicesummary[0].jobName;
        });
        }
    }

    //---------- Dev:Sachin; CUST-6661; 29-Apr-2025
    countdiscreption(str) {
        this.maxLength = str.length;
    }
    descriptionLabelChange(str)
    {
        if (str?.length >= 1500)
        {
            this.checkerrordescription = true;
        }
        else
        {
            this.checkerrordescription = false;
        }
    }
    //----------

  clearFormValidation() { // Dev:Ramya; CUST-1815; 28Nov2022
    this.validateDate = false;
    this.validateDescription = false;
    this.validateSupplierName = false;
    this.validatenoOfUnits = false;
    this.validateUnitCost = false;
    this.validateDate = false;
  }
    addUpdateDisbursement(disbursementForm: NgForm) {  
    if (this.disbursement.jobId != null || this.disbursement.jobId != undefined)
      this.disbursement.jobId = this.disbursement.jobId.toString();
        if (this.checkFormvalidation()) {
            this.isButtonDisabled = false;         // Dev:Mani; CUST-3348; 10JAN2024
            return false;
        }
        else {
            this.isButtonDisabled = true;         // Dev:Mani; CUST-3348; 10JAN2024
        }
    if (!this.validate())
      return false;
    
    if (disbursementForm.form.invalid) {     
      return;
    }
    if(!(this.subTotal && this.GSTValue && this.total)){
      this.disbursementCostCalc();
    }
    this.disbursement.disbursementDate = this.datepipe.transform(this.disbursement.disbursementDate, 'yyyy-MM-dd');
    this.disbursement.subTotal = this.subTotal.toFixed(6).toString();
    this.disbursement.GSTValue = this.GSTValue.toFixed(6).toString();
    this.disbursement.total = this.total.toFixed(6).toString();
    this.disbursement.taxTypeId = this.selectedTaxTypeId;
    let value = this.Invoicesummary.filter(item => item.jobName == this.disbursement.jobName);
    this.disbursement.jobId = value[0].jobId.toString();
    this.disbursementService.addEditDisbursement(this.disbursement).pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      this.clickgraphgenerate.emit();
        if (result.success) {
        if (this.isEditDisbursement) {
          this.toastr.success('Update Disbursement Successfully', 'Disbursement');          
          this.isEditDisbursement = false;
        }          
        else {

          this.toastr.success('Added Disbursement Successfully', 'Disbursement');
        }
        disbursementForm.resetForm();
        this.clearFormValidation();
        this.cleanDisbursement();
        this.isEditDisbursement = false;
        this.closeDisbursePopUp.emit({
          customField: result.customFields?.[0],
          disbursement: result.result?.[0]
        });
      }
      else {
        this.toastr.warning(result?.message ?? 'Failed to update disbursement', 'Disbursement');
      }
        
    }); 
  }
  cleanDisbursement() {    
    this.disbursement = new Disbursement(); (document.getElementById("disbursementName") as HTMLInputElement).value = "undefined";
  }
  cleandis(disbursementForm) {
    this.clearFormValidation();
    this.cleanDisbursement();
    disbursementForm.submitted = false;
    disbursementForm.resetForm();
  }
  disbursementMasterCombo: any;

  GetDisbursementMasterCombo(includeArchivedId: number = null) {
   // Developer Shahid Anwar Ticket CUST-1179 Date: 09-05-2022
    this.disbursementService.GetMasterDisbursementList().pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      let filteredData = result.filter(item => item.isArchived == false || item.disbursementMasterId === includeArchivedId);
      let disbursementList = [];
      for (const element of filteredData) {
        let disb = new DisbursementDetail();
        disb.disbursementMasterId = element.disbursementMasterId;
        disb.name = element.disbursementName;
        disbursementList.push(disb)
      }
      this.disbursementMasterCombo = disbursementList;
       
      if (this.disbursementMasterCombo.length ==0) {
        this.showdistextbox = true;
        this.showdiselect = false;
      }
      else {
        this.showdistextbox = false;
        this.showdiselect = true;
      }
    });

  }
  dateFormatSet(event) {
    if (event.target.value != "") {

      if (event.target.value.split('/').length == 2) {
        this.datemaxlength = 9;
      }
      else if (event.target.value.split('/').length == 3) {
        this.datemaxlength = 10;
      }
      else {
        this.datemaxlength = 8;
      }
    }
  }

  public total:any=0;
  public subTotal:any=0;
  public GSTValue:any=0;
   
  disbursementNoOfUnitCalc() {
    if (this.disbursement.noOfUnits != null && this.disbursement.noOfUnits != undefined && this.disbursement.unitCost != undefined) {
        this.disbursement.total = (this.disbursement.noOfUnits * this.disbursement.unitCost).toFixed(2);
    }
  }

  disbursementJobTitle(jobid, jobCode, jobName) {
    this.disbursement.jobId = jobid;
    this.disbursement.jobName = jobName;
    this.disbursement.jobCode = jobCode;
  }
  getDisbursementbyId(did) {
    this.disbursementService.GetDisbursementDetail(did).pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {
      this.disbursement = new Disbursement()
      let resultDis = result;     
      this.disbursement.disbursementMasterRefId = parseInt(resultDis.disbursementMasterRefId);
      this.disbursement.disbursementId = resultDis.disbursementId.toString();
      this.disbursement.jobId = resultDis.jobId;
      const dateFormat = 'MM-DD-YYYY HH:mm:ss';
      this.disbursement.disbursementDate = moment(resultDis.disbursementDate, dateFormat);
      this.disbursement.description = resultDis.description;
      this.disbursement.supplierName = resultDis.supplierName;
      this.disbursement.GST = resultDis.gst;
      this.disbursement.subTotal = resultDis.subTotal.toFixed(2).toString();
      this.disbursement.GSTValue = resultDis.gstValue.toFixed(2).toString();
      this.disbursement.noOfUnits = resultDis.noOfUnits.toString();
      this.disbursement.unitCost = resultDis.unitCost.toString();
      this.disbursement.total = resultDis.total.toFixed(2).toString();     
      this.disbursement.disbursementMasterRefId = resultDis.disbursementMasterRefId;
      this.disbursement.taxTypeId = this.selectedTaxTypeId = resultDis.taxTypeId;
      this.disbursement.isIncludeTax = this.isIncludeTaxChecked = resultDis.isIncludeTax;
      this.disbursementJobTitle(this.disbursement.jobId, resultDis.jobCode, resultDis.jobName);
      this.GetDisbursementMasterCombo(this.disbursement.disbursementMasterRefId);
    });
  };
  disbursementMarkPercent() {
    if (this.disbursement.markUp != null && this.disbursement.markUp != undefined) {
      let valMark = Number(this.disbursement.markUp)
      if (valMark <= 0 && valMark>100)
      {
        this.toastr.warning("MarkUp value invalid", 'Disbursement');
      }
      this.untiPOrMarkUpRequired = false;
    }
  }
  onDisbursementDateChange($event) {
  }
  closePopUp() {
    this.isEditDisbursement = false;    
    this.closeDisbursePopUp.emit({
      customField: false,
      disbursement: false
    });
  }  
  getDisbursementMasterbyId(msid) {
    this.disbursementService.GetDisbursementMasterById(msid).pipe(takeUntil(this.unsubscribe)).subscribe((result: any) => {              
        this.disbursement.noOfUnits = result.noOfUnits.toString();
        this.disbursement.unitCost = result.unitCost.toString();
        this.disbursement.description = result.description.toString();
        this.disbursement.supplierName = result.supplierName.toString();
        this.disbursementCostCalc();
    });
  }

  // Rahul Newara 15-04-2024 CUST-3873
    GetMinInvoiceDate() { 
        this._wipControlService.GetMinInvoiceDate().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
            if (result) {
                this.invoiceMinDate = result;
            }
        });
    }
  numberOnly(evt): boolean {
    evt = (evt) ? evt : window.event;
    let charcode = (evt.which) ? evt.which : evt.keyCode;
    if (charcode === 45) {
      return false;
    }
    if (charcode != 109 && charcode > 31 && (charcode < 48 || charcode > 57) && charcode != 46 && charcode != 45) {
      return false;
    }
    return true;
  }
  clientSearchFn(term: string, item: any): boolean {

    if (!term) return true;

    const words = term.toLowerCase().trim().split(/\s+/);

    const searchableText = `
    ${item.clientName || ''}
    ${item.clientCode || ''}
  `.toLowerCase();

    //  EACH word must match somewhere
    return words.every(word => searchableText.includes(word));
  }

  getDisbursementClientList() {
    this._clientService.GetClientListForCombo().pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {  
          this.disbursementClientList = result.filter(x => !(x.status == 'Archive' || x.status == 'Lost'));
        }       
    });
  }
}

class DisbursementDetail {
  public disbursementMasterId: any = 0;
  public name: any = "";
}
